import * as React from 'react';
import { useState } from 'react';
import TemplateForm from '../../components/Template/TemplateForm/TemplateForm';
var Template = function () {
    var _a = useState(false), isEdit = _a[0], setIsEdit = _a[1];
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432\u043E \u0428\u0430\u0431\u043B\u043E\u043D"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-5" },
                    React.createElement(TemplateForm
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        isEdit: setIsEdit }))))));
};
export default Template;



//////////////////
// WEBPACK FOOTER
// ./src/views/Templates/Template.tsx
// module id = 486
// module chunks = 0